import { RouteObject } from "react-router-dom";
import {
  DOCUMENT_REGISTER_TYPE_LIST_PATH,
  DocumentRegisterTypeListPage,
} from "@/modules/document-register/pages/document-register-type-list-page";
import {
  DOCUMENT_REGISTER_LIST_PATH,
  DocumentRegisterListPage,
} from "@/modules/document-register/pages/document-register-list-page";
import {
  DOCUMENT_REGISTER_TYPE_PATH,
  DocumentRegisterTypePage,
} from "@/modules/document-register/pages/document-register-type-page";
import {
  DOCUMENT_REGISTER_PATH,
  DocumentRegisterPage,
} from "@/modules/document-register/pages/document-register-page";

export const documentRegister: RouteObject[] = [
  {
    path: DOCUMENT_REGISTER_TYPE_LIST_PATH,
    element: <DocumentRegisterTypeListPage />,
  },
  {
    path: DOCUMENT_REGISTER_LIST_PATH,
    element: <DocumentRegisterListPage />,
  },
  {
    path: DOCUMENT_REGISTER_TYPE_PATH,
    element: <DocumentRegisterTypePage />,
  },
  {
    path: DOCUMENT_REGISTER_PATH,
    element: <DocumentRegisterPage />,
  },
];
